import React, { useState } from 'react';
import SectionHeader from './SectionCard/SectionHeader';
import TopicsList from './SectionCard/TopicsList';
import LockedSectionCard from './LockedSectionCard';
import { SectionData } from '@/types';

interface SectionCardProps {
    section: SectionData;
    courseSlug: string;
    isExpanded?: boolean;
    onToggle?: () => void;
    sectionNumber?: number;
}

const SectionCard: React.FC<SectionCardProps> = ({
    section,
    courseSlug,
    isExpanded = false,
    onToggle,
    sectionNumber
}) => {
    const [expanded, setExpanded] = useState(isExpanded);

    // If section is locked and user can't access it, show locked card
    if (section.is_locked && !section.can_access) {
        return (
            <LockedSectionCard
                section={section}
                sectionNumber={sectionNumber}
            />
        );
    }

    const handleToggle = () => {
        if (onToggle) {
            onToggle();
        } else {
            setExpanded(!expanded);
        }
    };
    const isCurrentlyExpanded = onToggle ? isExpanded : expanded;

    return (
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:border-gray-300 transition-all duration-200">
            {/* Section Header */}
            <SectionHeader
                section={section}
                sectionNumber={sectionNumber}
                isExpanded={isCurrentlyExpanded}
                onToggle={handleToggle}
                courseSlug={courseSlug}
            />

            {/* Topics List */}
            <TopicsList
                topics={section.topics}
                evaluations={section.evaluations}
                assignments={section.assignments}
                amaSeries={section.ama_series}
                courseSlug={courseSlug}
                isExpanded={isCurrentlyExpanded}
            />
        </div>
    );
};

export default SectionCard;